import { useEffect, useState } from 'react';

import {
  monthlyCutsSendToPayrollService,
  mapPayrollSubmissionAvailability,
} from '@/api/domains/attendance';


export interface UsePayrollSubmissionAvailabilityResult {
  // true solo cuando la empresa tiene una integración de remuneraciones activa.
  available: boolean;
  // Sistema de remuneraciones de destino informado por el backend (por defecto 'REX').
  targetSystem: string;
  // true una vez resuelta la consulta (éxito/error), para distinguir "cargando" de "no disponible".
  isLoaded: boolean;
}

// Carga una única vez la disponibilidad de la integración de remuneraciones para la empresa
// autenticada. Solo consulta cuando `enabled` es true (el listado la activa únicamente con permiso
// de edición). Un fallo se trata como "no disponible" en silencio: es un sondeo de fondo que no
// debe generar un toast de error; la UI simplemente deshabilita la acción.
export function usePayrollSubmissionAvailability(
  enabled: boolean,
): UsePayrollSubmissionAvailabilityResult {
  const [available, setAvailable] = useState(false);
  const [targetSystem, setTargetSystem] = useState('REX');
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (!enabled) {
      setAvailable(false);
      setIsLoaded(false);
      return;
    }

    const controller = new AbortController();
    void (async () => {
      const response = await monthlyCutsSendToPayrollService.getAvailability(controller.signal);
      if (response.error?.code === 'ABORTED') return;

      if (response.success && response.data) {
        const availability = mapPayrollSubmissionAvailability(response.data);
        setAvailable(availability.available);
        setTargetSystem(availability.targetSystem);
      } else {
        setAvailable(false);
      }
      setIsLoaded(true);
    })();

    return () => { controller.abort(); };
  }, [enabled]);

  return { available, targetSystem, isLoaded };
}

export default usePayrollSubmissionAvailability;
